import { useFetchStudentMessages } from "../../../hooks/http/useFetchStudentMessages";
import { useQueryError } from "../../../hooks/http/useQueryError";
import { StudentWithoutBillingPlanInterface } from "../../../interfaces/StudentInterface";
import MessageList from "../MessageList";
import { useChangeBotMessageStatus } from "./useChangeBotMessageStatus";
import { useDeleteMessage } from "./useDeleteMessage";

export const StudentMessageList = ({
  sectionId,
  student,
}: {
  sectionId: string;
  student: StudentWithoutBillingPlanInterface;
}) => {
  const { isLoading, error, isFetchingNextPage, fetchNextPage, messages } =
    useFetchStudentMessages({
      studentId: student.id,
    });
  useQueryError(error);

  const deleteMessage = useDeleteMessage({
    sectionId: sectionId,
  });

  const { changeBotMessageStatusDone, changeBotMessageStatusIgnored } =
    useChangeBotMessageStatus();

  const handleLoadMore = () => {
    fetchNextPage();
  };

  return (
    <MessageList
      student={student}
      messages={messages}
      isLoading={isLoading || isFetchingNextPage}
      loadMore={handleLoadMore}
      changeBotMessageStatusDone={changeBotMessageStatusDone}
      changeBotMessageStatusIgnored={changeBotMessageStatusIgnored}
      deleteMessage={deleteMessage}
    />
  );
};
